import { render } from "./CategoryLabel.vue?vue&type=template&id=5e742828&lang=pug"
import script from "./CategoryLabel.vue?vue&type=script&lang=js"
export * from "./CategoryLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__